// extracted by mini-css-extract-plugin
export var container = "_dp-1";
export var editor = "_dp-2";
export var resizable = "_dp-3";
export var wrapper = "_dp-0";